import {defineAsyncComponent} from 'vue';

const ReportParamDemo = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamDemo.vue'));
const ReportParam_B01_BCTC = defineAsyncComponent(() => import('@/views/report/parameters/ReportParam_B01_BCTC.vue'));
const ReportParam_B02_BCTC = defineAsyncComponent(() => import('@/views/report/parameters/ReportParam_B02_BCTC.vue'));
const ReportParam_S02bH = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S02bH.vue'),
);
const CopyValueDetail = defineAsyncComponent(() => import('@/components/popup/CopyValueDetail.vue'));
const ReportParam_B04_BCQT_KTNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B04_BCQT_KTNN.vue'),
);
const ReportParam_B01_BCQT_KTNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_B01_BCQT_KTNN.vue'),
);
const ReportParamC210NSTT19 = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamC210NSTT19.vue'));
// Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)
const ReportParam05TT = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam05TT/ReportParam05TT.vue'),
);

// Mẫu 04a/TT: Giấy đề nghị thanh toán vốn (PBI 59528)
const ReportParamDNTTV04a = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamDNTTV04a.vue'));
// Mẫu 04a/TT: Giấy đề nghị thanh toán vốn (PBI 59528)
const ReportParam_DNTTVDT_MS11_ND11 = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_DNTTVDT_MS11_ND11.vue'),
);
const ReportParamPaymentPurchaseTT08 = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParamPaymentPurchaseTT08.vue'),
);
// mẫu sổ chi tiết bán hàng (PBI 59579)
const ReportParamSaleDetailBook = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamSaleDetailBook.vue'),
);

// Sổ nhật ký bán hàng
const ReportParam_SaleDiary = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_SaleDiary.vue'),
);

// S11-H: Sổ kế toán chi tiết quỹ tiền mặt (PBI 59570)
const ReportParam_S11H = defineAsyncComponent(() => import('@/views/report/parameters/ReportParam_S11H.vue'));
//Form tham số báo cáo Sổ chi tiết mua hàng
const ReportParam_PurchaseDetailBook = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_PurchaseDetailBook/ReportParam_PurchaseDetailBook.vue'),
);

// Mẫu S104-H: Sổ theo dõi kinh phí NSNN cấp bằng Lệnh chi tiền (PBI 59611)
const ReportParam_S104_H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S104_H.vue'),
);
// S105-H-I
const ReportS105_H_I = defineAsyncComponent(() => import('@/views/report/parameters/staticreport/ReportS105_H_I.vue'));
// S106-H-I
const ReportS106_H_I = defineAsyncComponent(() => import('@/views/report/parameters/staticreport/ReportS106_H_I.vue'));
// mẫu S105-H Phần 2: Sổ theo dõi nguồn phí khấu trừ, được để lại (Phần II)
const ReportParam_S105_H_2 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S105_H_2.vue'),
);
// mẫu S106-H Phần 2: Sổ theo dõi nguồn thu hoạt động khách được để lại (Phần II)
const ReportParam_S106_H_2 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S106_H_2.vue'),
);

// Mẫu số C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)
const ReportParamC205NSND11 = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamC205NSND11.vue'));

// [CT] Ủy nhiệm chi (Agribank)
const ReportParam_CTBankWithDraw = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_CTBankWithDraw.vue'),
);

// Mẫu S13-H: Sổ kho (PBI 60465)
const ReportParamS13H = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamS13H.vue'));

// Mẫu S21-H: Sổ kho (PBI 60465)
const ReportParamS21H = defineAsyncComponent(() => import('@/views/report/parameters/ReportParam_S21H_BCVTHH.vue'));

const ReportParam_InventoryBookMaster = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_InventoryBookMaster.vue'),
);

// Mẫu số 06-ĐCSDTK/KBNN: Bảng xác nhận số dư tài khoản tiền gửi tại KBNN (Nghị định 11/2020/NĐ-CP)
const ReportParam_06_DCSDTK_KBNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_06_DCSDTK_KBNN.vue'),
);

// Mở form tham số cho mấu UNC Eximbank,ACB,Agribank,BIDV,...
const ReportParam_UNC = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_UNC.vue'),
);
const ReportParam_UNC_Excel = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_UNC_Excel.vue'),
);

// Tham số lệnh chi Vietinbank
const ReportParam_Payment_Order_Techcombank = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_Payment_Order_Techcombank.vue'),
);

// BCTC_05
const ReportParam_BCTC_05 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BCTC_05.vue'),
);

// BCTC_04
const ReportParam_BCTC_04 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BCTC_04.vue'),
);

// BCTC 03a
const ReportParam_BCTC_03a = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BCTC_03a.vue'),
);
// B02_TT90_2018
const ReportB02_TT90_2018Popup = defineAsyncComponent(() => import('@/views/report/ReportB02_TT90_2018Popup.vue'));

// S101-H-I
const ReportS101_H_I = defineAsyncComponent(() => import('@/views/report/parameters/dynamicReport/ReportS101_H_I.vue'));

const ReportParam_C203_ND11_63 = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_C203_ND11_63.vue'),
);

// mẫu S02c-H: Sổ cái - Hình thức chứng từ ghi sổ (PBI 59376)
const ReportParam_S02C_H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S02C_H.vue'),
);
// mẫu S02c-H: Sổ cái - Hình thức chứng từ ghi sổ (PBI 59376)
const ReportParam_SummaryAccount = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_SummaryAccount.vue'),
);

// mẫu B01_BCQT: [BC] B01/BCQT: Báo cáo quyết toán kinh phí hoạt động (PBI 59642)
const ReportParam_01_BCQT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_01_BCQT.vue'),
);

// mẫu B01_BCQT: [BC] B01/BCQT: đặc thù hải dương
const ReportParamB01_BCQT_HD = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamB01_BCQT_HD.vue'),
);
// mẫu B01_BCQT_TCTK: [BC] B01/BCQT: Báo cáo quyết toán kinh phí hoạt động (PBI 216917) Đặc thù tổng cục thống kê
const ReportParam_01_BCQT_TCTK = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_01_BCQT_TCTK.vue'),
);

const ReportParam_S03_H_Budget = defineAsyncComponent(() =>
  import('@/views/report/parameters/static/ReportParam_S03_H_Budget.vue'),
);

// S05-H: Bảng cân đối số phát sinh
const ReportParam_S05H = defineAsyncComponent(() => import('@/views/report/parameters/ReportParam_S05H.vue'));

// S31-H: Sổ chi tiết các tài khoản
const ReportParam_S31H = defineAsyncComponent(() => import('@/views/report/parameters/ReportParam_S31H.vue'));

//Phụ biểu F01-01/BCQT: Báo cáo chi tiết chi từ nguồn NSNN và nguồn phí được khấu trừ, để lại
const ReportParam_01_01_BCQT_Master = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_01_01_BCQT_Master.vue'),
);

const ReportParam_F01_02_BCQT_P2 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_F01_02_BCQT_P2.vue'),
);

//Thuyết minh B01/BSTT báo cáo bổ sung thông tin tài chính
const ReportParam_B01_BSTT_TM = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B01_BSTT_TM.vue'),
);

// mẫu B02_BCQT: [BC] B02/BCQT: Báo cáo thực hiện xử lý kiến nghị của kiểm tra, thanh tra, tài chính (PBI 59643)
const ReportParam_B02_BCQT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B02_BCQT.vue'),
);

// mẫu B03_BCQT: [BC] B03/BCQT: Thuyết minh báo cáo quyết toán đặc thù BTTTT
const ReportParam_B03_BCQT_BTTTT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B03_BCQT_BTTTT.vue'),
);
// mẫu B03_BCQT: [BC] B03/BCQT: Thuyết minh báo cáo quyết toán
const ReportParam_B03_BCQT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B03_BCQT.vue'),
);

// mẫu B03_BCQT: [BC] B03/BCQT: Thuyết minh báo cáo quyết toán
const ReportParam_B03_BCQT_TCTK = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B03_BCQT_TCTK.vue'),
);

//C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)
const C202bNSND112020_WithBankAccount = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C202bNSND112020_WithBankAccount.vue'),
);

//Giấy đề nghị mua ngoại tệ kiêm lệnh chi (Vietinbank).
const ParamForexOrderVietinBank = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ParamForexOrderVietinBank.vue'),
);

const C202aNSND112020_WithBankAccount = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C202aNSND112020_WithBankAccount.vue'),
);
// BCTC-03B: Báo cáo lưu chuyển tiền tệ (theo phương pháp gián tiếp)
const ReportParam_BCTC_03B = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BCTC_03B.vue'),
);

//C2-03/NS: Giấy đề nghị thanh toán tạm ứng (Nghị định 11/2020/NĐ-CP)
const C203NSND11 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C203NSND11.vue'));

const S01B_Voucher = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/S01B_Voucher.vue'));
const ReportParam_05QTT_TNCN_Voucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_05QTT_TNCN_Voucher.vue'),
);
const ReportParam_05KK_TNCN_Voucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_05KK_TNCN_Voucher.vue'),
);
const ReportParam_05_02_BK_QTT_TNCN_Voucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_05_02_BK_QTT_TNCN_Voucher.vue'),
);
const ReportParam_05KK_TNCN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_05KK_TNCN.vue'),
);
const ReportParam_0501BK_QTT_TNCN_Voucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_0501BK_QTT_TNCN_Voucher.vue'),
);
const ReportParam_05_02_BK_QTT_TNCN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_05_02_BK_QTT_TNCN.vue'),
);

const C2_06_NS_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C2_06_NS_ND112020.vue'),
);

//C37-HD: Giấy đề nghị thanh toán
const ReportParam_C37HD = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C37_HD.vue'));

//C37-HD: Giấy đề nghị thanh toán (Mẫu chi tiết từng dòng)
const ReportParam_C37HD_Detail = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C37_HD_Detail.vue'),
);

//C30-HD: Phiếu nhập kho
const C30_HD = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C30_HD.vue'));

//C30-HD: Phiếu nhập kho 2 liên
const C30_HD_2Copy = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C30_HD_2Copy.vue'));

//S03-H: Sổ Cái (dùng cho hình thức kế toán Nhật ký chung)
const ReportParamS03H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamS03H.vue'),
);
//Mẫu số 04-SDKP/ĐVDT: Tình hình thực hiện dự toán các các nhiệm vụ được chuyển nguồn sang năm sau (Nghị định 11/2020/NĐ-CP)
const ReportParamMS04 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamMS04.vue'),
);

//Báo cáo tình hình tăng giảm CCDC
const ReportParamSupplyIncreaseDecrease = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamSupplyIncreaseDecrease.vue'),
);
// S34-H: Sổ chi tiết thanh toán với khách hàng
const ReportParam_S34_H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S34_H.vue'),
);
// S33-H: Sổ chi tiết các khoản phải thu, phải trả nội bộ để theo dõi công nợ nội bộ
const ReportParam_S33H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S33H.vue'),
);
//BCTC-01bstt
const ReportParam_BCTC_01_BSTT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BCTC_01_BSTT.vue'),
);
//C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)
const C402aKBND11 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C402aKBND11.vue'));
//C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP) - Mẫu giao dịch với ngân hàng
const C402aBankND11 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C402aBankND11.vue'));
//C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)
const C402cKBND11 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C402cKBND11.vue'));

//Thuyết minh B01/BSTT báo cáo bổ sung thông tin tài chính
const ReportParam_S04_H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S04_H.vue'),
);

const ReportParamS12H = defineAsyncComponent(() => import('@/views/report/parameters/static/ReportParam_S12H.vue'));

//S61-H: Sổ chi tiết chi phí (Mẫu tiểu mục)
const ReportParamS61H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamS61H.vue'),
);
// mẫu S101-H Phần 2: Sổ tổng hợp theo dõi dự toán từ nguồn NSNN trong nước
const ReportParam_S101_H_2 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S101_H_2.vue'),
);
// mẫu S02a-H: Chứng từ ghi sổ
const ReportParam_S02a_H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S02a_H.vue'),
);
// Tham số lương
const ReportParam_SalarySheetNomal = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_SalarySheetNomal.vue'),
);
// mẫu truy linh lương
const ReportParam_RetroSalary = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_RetroSalary.vue'),
);
//Mẫu khấu trừ không thường xuyên
const ReportParam_Pa_Other_Outcome = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_Pa_Other_Outcome.vue'),
);
// mẫu truy linh lương trong thangs
const ReportParam_RetroSalaryForMonth = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_RetroSalaryForMonth.vue'),
);
// mẫu S02a-H: Chứng từ ghi sổ in tại màn hình chi tiết
const ReportParam_S02a_H_Voucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S02a_H_Voucher.vue'),
);
// mẫu Chứng từ ghi sổ in tại màn hình chi tiết
const ReportParam_S02a_H_PostedVoucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S02a_H_PostedVoucher.vue'),
);
//C2-03/NS: Giấy đề nghị thanh toán tạm ứng (Nghị định 11/2020/NĐ-CP)
const PaymentVoucherListPrintFromVoucher_ND11_2020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/PaymentVoucherListPrintFromVoucher_ND11_2020.vue'),
);
//C2-03/NS: Giấy đề nghị thanh toán tạm ứng (Nghị định 11/2020/NĐ-CP)
const PaymentVoucherListPrintFromVoucher_ND11_2020_vertical = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/PaymentVoucherListPrintFromVoucher_ND11_2020_vertical.vue'),
);

//Mẫu số 01a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước
const ReportParam_N01a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_N01a_SDKP_DVDT_ND112020.vue'),
);
//Mẫu số 01b-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước
const ReportParam_N01b_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_N01b_SDKP_DVDT_ND112020.vue'),
);
//Mẫu số 02a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước
const ReportParam_N02a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_N02a_SDKP_DVDT_ND112020.vue'),
);
//Mẫu số 02b-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước
const ReportParam_N02b_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_N02b_SDKP_DVDT_ND112020.vue'),
);
//C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)
const C2_05_NS_ND11 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C2_05_NS_ND11.vue'));
//S101-H Phần 3: Sổ tổng hợp theo dõi dự toán từ nguồn NSNN trong nước
const ReportParamS101HPIII = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamS101HPIII.vue'),
);
//S26-H: Sổ theo dõi tài sản cố định tại nơi sử dụng
const ReportParamS26H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamS26H.vue'),
);
//S62-H: Sổ chi phí sản xuất, kinh doanh (Hoặc đầu tư XDCB)
const ReportParamS62H = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamS62H.vue'));

//Form tham số báo cáo Sổ nhật ký mua hàng
const ReportParam_PurchaseDiary = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_PurchaseDiary.vue'),
);

// Tham số in chứng từ (chứng từ kế toán - vqphong - 03/11/2022)
const ReportParamAccountVoucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/reportParamAccountVoucher/ReportParamAccountVoucher.vue'),
);
const ReportParamAccountVoucherSummarySameInfo = defineAsyncComponent(() =>
  import('@/views/report/parameters/reportParamAccountVoucher/ReportParamAccountVoucherSummarySameInfo.vue'),
);
const ReportParamC41BB = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParamC41BB.vue'),
);
const ReportParamC40BB = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParamC40BB.vue'),
);
//C4-02b/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)
const C402bKBND11 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C402bKBND11.vue'));

const ReportParam_S01B = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S01B.vue'),
);
const SalaryMS09 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/SalaryMS09.vue'));

const ReportParamS01H = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamS01H.vue'));
// Sổ theo dõi Chuyển khoản
const ReportParamVoucherByTypeDiary = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParamVoucherByTypeDiary.vue'),
);

const SalaryMS09_PayrollItemFormula = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/SalaryMS09_PayrollItemFormula.vue'),
);
// [CT] Mẫu C4-08/KB: Giấy nộp tiền vào tài khoản (TT19/2020/TT-BTC)
const C408_KB_TT19 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C408_KB_TT19.vue'));
const C202aNSND112020_WithBankAccount_Offline = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C202aNSND112020_WithBankAccount_Offline.vue'),
);

const C202bNSND112020_WithBankAccount_Offline = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C202bNSND112020_WithBankAccount_Offline.vue'),
);

/**
 * Tham số in chứng từ (C02-HD: bảng thanh toán tiền lương và các khoản phụ cấp thep lương, các khoản nộp theo lương)
 * NHANH3 (16.11.2022)
 */
const ReportParam_C02_HD_Salary = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_C02_HD_Salary.vue'),
);

/**
 * Tham số mở popup Mẫu in C13-HD DVMINH 03/04/2023
 */
const ReportParam_C13_HD_Salary = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_C13_HD_Salary.vue'),
);


const ReportParam_Other_Income_Table = defineAsyncComponent(() => import('@/views/report/parameters/dynamicReport/ReportParam_Other_Income_Table.vue'));

// Mẫu 04a/TT: Giấy đề nghị thanh toán vốn (PBI 59528)
const ReportParamDNTHV04b = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamDNTHV04b.vue'));

const ReportParamC3ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParamC3ND112020.vue'),
);

const ReportParamC3ND112020_105 = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParamC3ND112020_105.vue'),
);

//C1-02/NS: Giấy nộp tiền vào ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)
const C1_02_NS_ND11 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C1_02_NS_ND11.vue'));

// Sổ chi tiết công nợ phải trả
const ReportParamLiabilityByObjectPurchase = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamLiabilityByObjectPurchase.vue'),
);

// Sổ tổng hợp công nợ phải trả
const ReportParamSummaryPayable = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamSummaryPayable.vue'),
);
// C43-BB- Giấy đề nghị thanh toán tạm ứng
const C43_BB = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C43_BB.vue'));

// C3-02/NS : Tham số báo cáo Giấy đề nghị thanh toán tạm ứng vốn đầu tư Nghị Định 11
const ReportParam_C302NS_ND11 = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C3-02NS_ND11.vue'),
);

//Tham số báo cáo số dư các chi tiết của 1 tài khoản
const ReportParam_AccountDetailBalance = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_AccountDetailBalance.vue'),
);

//Tham số báo cáo đối chiếu hạch toán tài chính và hạch toán ngoài bảng
const ReportParam_ComparisonReportParalell = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_ComparisonReportParalell.vue'),
);

//Tham số báo cáo tổng hợp tình hình kinh phí dự án
const ReportParam_SummaryProjectExpense = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_SummaryProjectExpense.vue'),
);

// S51-H: Sổ chi tiết doanh thu sản xuất, kinh doanh dịch vụ
const ReportParamS51H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamS51H.vue'),
);
// form tham số báo cáo chi tiết công nợ phải thu
const ReportParam_LiabilityObjectMonitor = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_LiabilityObjectMonitor.vue'),
);

// form tham số báo cáo tổng hợp công nợ phải thu
const ReportParam_SummaryReceivable = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_SummaryReceivable.vue'),
);

// S23-H: Bảng tổng hợp chi tiết nguyên liệu, vật liệu, công cụ dụng cụ và sản phẩm hàng hóa
const ReportParamS23H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamS23H.vue'),
);

// S22-H: Sổ chi tiết nguyên liệu, vật liệu, công cụ dụng cụ và sản phẩm hàng hóa
const ReportParamS22H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamS22H.vue'),
);

//InventoryInStockByBatch : Báo cáo tồn kho theo lô
const ReportParam_InventoryInStockByBatch = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_InventoryInStockByBatch.vue'),
);
// Báo cáo tồn kho theo theo chứng từ nhập
const ReportParam_InventoryInStockByInward = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_InventoryInStockByInward.vue'),
);

//C31-HD: Phiếu xuất kho
const C31_HD = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C31_HD.vue'));

// Mẫu Báo cáo tổng hợp công nợ NHCUONG 07.12.2022
const ReportParam_SummaryOther = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_SummaryOther.vue'),
);

// Mẫu tham số trong đối chiếu số dư KBĐT Mẫu số 01a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại Kho bạc nhà nước
const ReportParam_DCSD_N01a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_DCSD_N01a_SDKP_DVDT_ND112020.vue'),
);
// Mẫu tham số trong đối chiếu số dư KBĐT Mẫu số 02a-SDKP/ĐVDT
const ReportParam_DCSD_N02a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_DCSD_N02a_SDKP_DVDT_ND112020.vue'),
);
// Mẫu tham số báo cáo 06 cho kho bạc điện tử - Quản lý hồ sơ đối chiếu số dư - ncdinh 19/12/022
const ReportParam_DCSD_06_DCSDTK_KBNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_DCSD_06_DCSDTK_KBNN.vue'),
);

//Sổ chi tiết các tài khoản (Mở rộng)
const AccountLedgerDetail = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/AccountLedgerDetail.vue'),
);
// Tham số báo cáo S24H-Sổ tài sản cố định
const ReportParam_S24H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S24H.vue'),
);
// Tham số báo cáo Danh sách tài sản cố định theo loại
const ReportParam_FixedAssetListingUsedDepartment = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_FixedAssetListingUsedDepartment.vue'),
);

const ReportParam_MinutesInventoryFixedAsset = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_MinutesInventoryFixedAsset.vue'),
);
// Tham số báo cáo Sổ ghi giảm tài sản cố định
const ReportParamDecrementLedger = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamDecrementLedger.vue'),
);
// Báo cáo kiểm kê TSCĐ - mẫu phòng ban
const ReportParam_InventoryFixedAssetDepartment = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_InventoryFixedAssetDepartment.vue'),
);

// Sổ theo dõi tạm ứng
const ReportParam_AdvanceTracking = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_AdvanceTracking.vue'),
);

// Báo cáo Sổ cái tài khoản nhóm theo đối ứng
const ReportParam_GeneralLedgerCorresponding = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_GeneralLedgerCorresponding.vue'),
);

// S52H
const ReportParam_S52H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S52H.vue'),
);

// S31-H: Sổ chi tiết các tài khoản
const ReportParam_DCSD_N04a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_DCSD_N04a_SDKP_DVDT_ND112020.vue'),
);

// C34-HD: Phiếu giao nhận nguyên liệu, vật liệu, công cụ, dụng cụ
const ReportParam_C34_HD = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_C34_HD.vue'),
);
// Báo cáo kiểm kê tài sản cố định
const ReportParam_Inventory_FixedAsset = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_Inventory_FixedAsset.vue'),
);
//  Báo cáo tình hình tăng giảm TSCĐ theo mẫu QĐ 19/2006 để phản ánh tình hình tài sản hiện có tại đơn vị
const ReportParam_UpDown_FixedAsset = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_UpDown_FixedAsset.vue'),
);

const ReportParam_ReportSaleVoucherCompare = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_ReportSaleVoucherCompare.vue'),
);
// Đối chiếu chứng từ mua hàng và chứng từ thanh toán
const ReportParamComparePUInvoiceAndPayment = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamComparePUInvoiceAndPayment.vue'),
);

// Sai lệch B01
const B01_BCTC_Unbalence = defineAsyncComponent(() => import('@/views/report/B01_BCTC_Unbalence.vue'));

// Báo cáo quyết toán tổng hợp nhập xuất tồn
const ReportParam_GeneralImportExportReserveSettlement = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_GeneralImportExportReserveSettlement.vue'),
);

// Sổ chi tiết vật tư hàng hóa theo chứng từ nhập (PP đích danh)
const InwardOutwardDetailByVoucher = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/InwardOutwardDetailByVoucher.vue'),
);

// Tổng hợp kinh phí đã sử dụng đề nghị ghi thu, ghi chi
const SummaryProjectExpenseToUsed = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/SummaryProjectExpenseToUsed.vue'),
);
// C55- Báo cáo hao mòn
const ReportParam_AttritionCaculateBook = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_AttritionCaculateBook.vue'),
);
// 26H
const ReportParam_S26H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S26H.vue'),
);
// Tham số chứng từ: C02-17a. Lệ ghi thu, ghi chi ngân sách theo thông tư 19-2020 TT-BTC
const ReportParam_PaymentVoucherList_C217aNS192020_TTBTC = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/ReportParam_PaymentVoucherList_C217aNS192020_TTBTC.vue'),
);

//Tham số báo cáo Biểu số 3: Công khai thực hiện dự toán thu - chi ngân sách (Thông tư 90/2018/TT-BTC)
const ReportParam_B03_TT90_2018_KTNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B03_TT90_2018_KTNN.vue'),
);
// 08/QTDA: Tình hình thanh toán và công nợ của dự án
const ReportParam_08QTDA = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_08QTDA.vue'),
);

// [BC] Báo cáo chênh lệch thu, chi theo hoạt động SXKD, dịch vụ
const ReportParam_DifferenceReceiptExpenseByActivity = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_DifferenceReceiptExpenseByActivity.vue'),
);
// Báo cáo đối chiếu kinh phí rút và chi theo MLNS
const ReportParam_F02_01H_QD19 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_F02_01H_QD19.vue'),
);
// Liệt kê chứng từ kế toán theo mã thống kê
const ReportParam_VoucherListByStatisticsCode = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_VoucherListByStatisticsCode.vue'),
);

// Thống kê chứng từ kế toán
const ReportParam_AccountingVoucherList = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_AccountingVoucherList.vue'),
);

// Phụ biểu F01-01/BCQT: Báo cáo chi tiết chi từ nguồn NSNN và nguồn phí được khấu trừ, để lại (Kiểm toán nhà nước)
const ReportParam_01_01_BCQT_KTNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_01_01_BCQT_KTNN.vue'),
);

// B03 – CĐT: Thực hiện đầu tư
const ReportParam_CDT_B03 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_CDT_B03.vue'),
);

// 01/QTDA: Báo cáo tổng hợp quyết toán dự án hoàn thành
const ReportParam_01QTDA = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_01QTDA.vue'),
);

// Biểu số 58 - Phụ lục tổng hợp đối chiếu tại KBNN nơi giao dịch
const ReportParam_B58_KTNNNew = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B58_KTNNNew.vue'),
);

// F02 – CĐT: Chi tiết nguồn kinh phí đầu tư
const ReportParam_CDT_F02 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_CDT_F02.vue'),
);

// F03A – CĐT: Thực hiện đầu tư theo dự án, công trình, hạng mục công trình
const ReportParam_CDT_F03A = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_CDT_F03A.vue'),
);

// F03C – CĐT: Chi phí khác
const ReportParam_CDT_F03C = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_CDT_F03C.vue'),
);

// F03B – CĐT: Quyết toán vốn đầu tư theo dự án, công trình, hạng mục công trình hoàn thành bàn giao sử dụng
const ReportParam_CDT_F03B = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_CDT_F03B.vue'),
);
// Báo cáo B02_CDT: Nguồn vốn đầu tư
const ReportParam_CDT_B02 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_CDT_B02.vue'),
);

// Báo cáo C24-HD Bảng kê mua hàng
const ReportParam_C24 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_C24.vue'),
);

// 04/QTDA: Chi phí đầu tư đề nghị quyết toán theo công trình, hạng mục công trình hoàn thành - TT 96/2021
const ReportParam_04QTDA = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_04QTDA.vue'),
);
//Phụ biểu F01-01/BCQT: Báo cáo chi tiết chi từ nguồn NSNN và nguồn phí được khấu trừ, để lại(đặc thù tổng cục thống kê)
const ReportParam_01_01_BCQT_TCTK = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_01_01_BCQT_TCTK.vue'),
);
// B58_KTNN: Phụ lục tổng hợp đối chiếu tại KBNN
const ReportParam_B58_KTNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B58_KTNN.vue'),
);

// Báo cáo chi tiết kinh phí hoạt động của đặc thù sở giáo dục hải dương
const ReportParam_BudgetActivitySGDHD = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BudgetActivitySGDHD.vue'),
);

// Bảng in tổng hợp của 1 tài khoản
const ReportParam_SummaryByAccount = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_SummaryByAccount/ReportParam_SummaryByAccount.vue'),
);

const ReportParam_Government = defineAsyncComponent(() =>
  import('@/views/report/parameters/ReportParam_Government.vue'),
);

const ReportParam_C03_CCTT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_C03_CCTT.vue'),
);

const ReportParam_B03_TT90_2018 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B03_TT90_2018.vue'),
);
const ReportParam_B04_TT90 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B04_TT90.vue'),
);
// Biểu số 59 - Tình hình thực hiện dự toán của các nhiệm vụ được chuyển nguồn sang năm sau của các cấp theo hình thức rút dự toán
const ReportParamBS59 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamBS59.vue'),
);
// Biểu số 4: Quyết toán thu - chi nguồn NSNN, nguồn khác
const ReportParamB04TT612017BTC = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamB04TT612017BTC.vue'),
);
// Báo cáo Thống kê xuất kho theo đơn vị sử dụng tại đơn vị
const ReportParam_OSStatisticByDepartment = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_OSStatisticByDepartment.vue'),
);
// C23-HD: Biên bản kiểm kê vật tư, công cụ, sản phẩm, hàng hóa theo TT 107/2017/TT-BTC
const ReportParam_C23_HD = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_C23_HD.vue'),
);

const ReportParam_MA1_BCQT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_MA1_BCQT.vue'),
);

// Sổ ghi tăng tài sản cố định
const ReportParamIncrementFixedAssetBook = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamIncrementFixedAssetBook.vue'),
);
// Tổng hợp số thu dịch vụ của đơn vị sự nghiệp công
const ReportParamSummaryReceiptM02 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamSummaryReceiptM02.vue'),
);

// Báo cáo biểu số 59
const ReportParam_TT3422016_B59_KTNN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_TT3422016_B59_KTNN.vue'),
);
// C2-10 Phiếu điều chỉnh số liệu ngân sách (TT số 77/2017/TT-BTC)
const C210NSTT77 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C210NSTT77.vue'));

// Báo cáo tình hình kinh phí hoạt động của chi bộ, đảng bộ cơ sở xã, phường, thị trấn
const ReportParamReportingGovernment = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamReportingGovernment.vue'),
);

const ReportParam_03_SDKP_ĐVDT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_03_SDKP_ĐVDT.vue'),
);

// Đối chiếu kinh phí rút tạm ứng và thanh toán tạm ứng theo MLNS
const ReportParamAdvanceWithdrawByBudget = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamAdvanceWithdrawByBudget.vue'),
);

// Bảng kê chứng từ thực chi/ tạm ứng
const ReportParamRealExpense = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamRealExpense.vue'),
);
const FixedAssetDecreaseList = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/FixedAssetDecreaseList.vue'),
);

// báo cáo S53-H
const ReportParam_S53_H = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S53_H.vue'),
);

// Biên bản kiểm kê CCDC
const ReportParamMinutesInventoryTool = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamMinutesInventoryTool.vue'),
);

// Sổ theo dõi chi tiết tình hình thực hiện kinh phí đề tài
const ReportParam_VHL_DetailProject = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_VHL_DetailProject.vue'),
);

// Tổng hợp tình hình kinh phí thực hiện đề tài
const ReportParam_VHL_SummaryProject = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_VHL_SummaryProject.vue'),
);

const ReportParam_BudgetSourceUsing_BTTTT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BudgetSourceUsing_BTTTT.vue'),
);
// Báo cáo Bảng kê chi tiết chứng từ
const ReportParam_DetailByAccountingSource = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_DetailByAccountingSource.vue'),
);

// Mẫu số B5 - 03/BC-NS/TABMIS: Tình hình sử dụng dự toán chi thường xuyên NSTW (cấp tỉnh/cấp huyện/cấp xã) theo hình thức rút dự toán
const ReportParam_B05_BTTTT = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_B05_BTTTT.vue'),
);
// Danh sách chứng từ chưa sinh hạch toán đồng thời
const ReportParam_VoucherNoParalell = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_VoucherNoParalell.vue'),
);
// Báo cáo thực hiện cam kết chi
const ReportParamPerformPaymentCommitment = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamPerformPaymentCommitment.vue'),
);

// Sổ chi tiết các tài khoản (TK 007)
const ReportParam_AccountBookingExtension007 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_AccountBookingExtension007.vue'),
);

// Sổ chi tiết các tài khoản theo dự án/công trình/hạng mục công trình
const ReportParam_AccountBookingByProject = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_AccountBookingByProject.vue'),
);

// S103-H: Sổ theo dõi nguồn vay nợ nước ngoài (Phần I)
const ReportParam_S103H_P1 = defineAsyncComponent(() =>
  import('@/views/report/parameters/dynamicReport/ReportParam_S103H_P1.vue'),
);

// Báo cáo Sổ chi tiết công nợ phải trả theo ngoại tệ
const ReportParam_PayableDetailByCurrency = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_PayableDetailByCurrency.vue'),
);

// Mẫu số 05-1/BK-QTT-TNCN: Phụ lục Bảng kê chi tiết cá nhận thuộc diện tính thuế theo biểu lũy tiền từng phần để nộp cho cơ quan Thuế theo quy định
const ReportParam_0501BK_QTT_TNCN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_0501BK_QTT_TNCN.vue'),
);

const ReportParam_S103HPII = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S103HPII.vue'),
);

// Sổ theo dõi nguồn viện trợ S102H_P2
const ReportParam_S102_H_2 = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_S102_H_2.vue'),
);
// 05/QTT-TNCN: Tờ khai quyết toán thuế TNCN theo TT số 80/2021/TT-BTC để nộp cơ quan Thuế
const ReportParam_05QTT_TNCN = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_05QTT_TNCN.vue'),
);

// Tổng hợp công nợ phải thu theo ngoại tệ
const ReportParam_ReceivablePayableSummaryByCurrency = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_ReceivablePayableSummaryByCurrency.vue'),
);

// Tổng hợp công nợ phải trả theo ngoại tệ
const ReportParamSummaryPayableByCurrency = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParamSummaryPayableByCurrency.vue'),
);

// Sổ chi tiết công nợ phải thu theo ngoại tệ
const ReportParam_ReceiptableDetailByCurrency = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_ReceiptableDetailByCurrency.vue'),
);

// Mẫu số C2-03/NS: Giấy đề nghị thanh toán tạm ứng (Nghị định 11/2020/NĐ-CP)
const C203NSTT77 = defineAsyncComponent(() => import('@/views/report/parameters/voucherReport/C203NSTT77.vue'));
const PaymentVoucherListPrintFromVoucher_TT39_2016 = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/PaymentVoucherListPrintFromVoucher_TT39_2016.vue'),
);

// C3-02/NS: Giấy đề nghị thanh toán tạm ứng, ứng trước vốn đầu tư (Thông tư số 77/2017/TT-BTC)
const ReportParam_C302NS_TT77 = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/C3-02NS_TT77.vue'),
);
// Danh sách chứng từ thanh toán chưa có chứng từ mua hàng
const ReportParam_ListDataForPaymentNoPUInvoice = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_ListDataForPaymentNoPUInvoice.vue'),
);
// Giấy đề nghị xác nhận chi phí hợp lệ vốn sự nghiệp (NĐ 11/2020/TT-BTC)
const ReportParamMS14_ND11 = defineAsyncComponent(() => import('@/views/report/parameters/ReportParamMS14_ND11.vue'));

// In bảng kê offline
const PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline = defineAsyncComponent(() =>
  import('@/views/report/parameters/offlineReport/PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline.vue'),
);
// Chứng từ kế toán
const ReportParamAccountVoucher_Offline = defineAsyncComponent(() =>
  import('@/views/report/parameters/offlineReport/ReportParamAccountVoucher_Offline.vue')
);
// Báo cáo chi tiết kinh phí hoạt động
const ReportParam_BudgetActivity = defineAsyncComponent(() =>
  import('@/views/report/parameters/staticreport/ReportParam_BudgetActivity.vue'),
);

export function registerParams(app) {
  app.component('CopyValueDetail', CopyValueDetail);
  app.component('ReportParamDemo', ReportParamDemo);
  app.component('ReportParam_B01_BCTC', ReportParam_B01_BCTC);
  app.component('ReportParamDNTTV04a', ReportParamDNTTV04a);
  app.component('ReportParam_DNTTVDT_MS11_ND11', ReportParam_DNTTVDT_MS11_ND11);
  app.component('ReportParamPaymentPurchaseTT08', ReportParamPaymentPurchaseTT08);
  app.component('ReportParamMS14_ND11', ReportParamMS14_ND11);
  app.component('ReportParam_S104_H', ReportParam_S104_H);
  app.component('ReportS105_H_I', ReportS105_H_I);
  app.component('ReportS106_H_I', ReportS106_H_I);
  app.component('ReportParam_S105_H_2', ReportParam_S105_H_2);
  app.component('ReportParam_S106_H_2', ReportParam_S106_H_2);

  app.component('ReportParamS13H', ReportParamS13H);
  app.component('ReportParamS21H', ReportParamS21H);
  app.component('ReportParamS12H', ReportParamS12H);
  app.component('ReportParam_InventoryBookMaster', ReportParam_InventoryBookMaster);
  app.component('ReportParamSaleDetailBook', ReportParamSaleDetailBook);
  app.component('ReportParam_SaleDiary', ReportParam_SaleDiary);
  app.component('ReportParamC210NSTT19', ReportParamC210NSTT19);
  app.component('ReportParam_06_DCSDTK_KBNN', ReportParam_06_DCSDTK_KBNN);
  app.component('ReportParam_BCTC_05', ReportParam_BCTC_05);
  app.component('ReportParam_BCTC_04', ReportParam_BCTC_04);
  app.component('ReportParam_BCTC_03a', ReportParam_BCTC_03a);
  app.component('ReportParam05TT', ReportParam05TT);
  app.component('ReportParam_S11H', ReportParam_S11H);
  //C2_05_NS_ND11
  app.component('ReportParamC205NSND11', ReportParamC205NSND11);
  app.component('B01_BCTC_Unbalence', B01_BCTC_Unbalence);

  app.component('ReportParam_InventoryInStockByBatch', ReportParam_InventoryInStockByBatch);

  //[CT] Ủy nhiệm chi (Agribank)
  app.component('ReportParam_CTBankWithDraw', ReportParam_CTBankWithDraw);

  app.component('ReportParam_C203_ND11_63', ReportParam_C203_ND11_63);
  app.component('ReportParam_PurchaseDetailBook', ReportParam_PurchaseDetailBook);
  app.component('ReportB02_TT90_2018Popup', ReportB02_TT90_2018Popup);
  app.component('ReportParam_S02C_H', ReportParam_S02C_H);
  app.component('ReportParam_01_BCQT', ReportParam_01_BCQT);
  app.component('ReportParam_01_BCQT_TCTK', ReportParam_01_BCQT_TCTK);
  app.component('ReportParam_S03_H_Budget', ReportParam_S03_H_Budget);

  app.component('ReportParam_S05H', ReportParam_S05H);
  app.component('ReportParam_S31H', ReportParam_S31H);
  app.component('ReportParam_01_01_BCQT_Master', ReportParam_01_01_BCQT_Master);
  app.component('ReportParam_SummaryAccount', ReportParam_SummaryAccount);
  app.component('ReportParam_F01_02_BCQT_P2', ReportParam_F01_02_BCQT_P2);
  app.component('ReportParam_B01_BSTT_TM', ReportParam_B01_BSTT_TM);
  app.component('ReportParam_B02_BCQT', ReportParam_B02_BCQT);
  app.component('ReportParam_B03_BCQT', ReportParam_B03_BCQT);
  app.component('ReportParam_B03_BCQT_TCTK', ReportParam_B03_BCQT_TCTK);
  app.component('C202bNSND112020_WithBankAccount', C202bNSND112020_WithBankAccount);
  app.component('C202aNSND112020_WithBankAccount', C202aNSND112020_WithBankAccount);
  app.component('ReportParam_BCTC_03B', ReportParam_BCTC_03B);
  app.component('C203NSND11', C203NSND11);
  app.component('C203NSTT77', C203NSTT77);
  app.component('S01B_Voucher', S01B_Voucher);
  app.component('ReportParam_05QTT_TNCN_Voucher', ReportParam_05QTT_TNCN_Voucher);
  app.component('ReportParam_05KK_TNCN_Voucher', ReportParam_05KK_TNCN_Voucher);
  app.component('ReportParam_05_02_BK_QTT_TNCN_Voucher', ReportParam_05_02_BK_QTT_TNCN_Voucher);
  app.component('ReportParam_05KK_TNCN', ReportParam_05KK_TNCN);
  app.component('ReportParam_0501BK_QTT_TNCN_Voucher', ReportParam_0501BK_QTT_TNCN_Voucher);
  app.component('C2_06_NS_ND112020', C2_06_NS_ND112020);
  app.component('ReportParam_C37HD', ReportParam_C37HD);
  app.component('ReportParam_C37HD_Detail', ReportParam_C37HD_Detail);
  app.component('C30_HD', C30_HD);
  app.component('C30_HD_2Copy', C30_HD_2Copy);
  app.component('ReportParamS03H', ReportParamS03H);
  app.component('ReportParamMS04', ReportParamMS04);
  app.component('ReportParamSupplyIncreaseDecrease', ReportParamSupplyIncreaseDecrease);
  app.component('ReportParamS61H', ReportParamS61H);
  app.component('ReportParam_BCTC_01_BSTT', ReportParam_BCTC_01_BSTT);
  app.component('C402aKBND11', C402aKBND11);
  app.component('C402aBankND11', C402aBankND11);
  app.component('C402cKBND11', C402cKBND11);
  app.component('ReportParam_B02_BCTC', ReportParam_B02_BCTC);
  app.component('ReportParam_S02bH', ReportParam_S02bH);
  app.component('ReportParam_B04_BCQT_KTNN', ReportParam_B04_BCQT_KTNN);
  app.component('ReportParam_B01_BCQT_KTNN', ReportParam_B01_BCQT_KTNN);
  app.component('ReportParam_S04_H', ReportParam_S04_H);
  app.component('ReportParam_S34_H', ReportParam_S34_H);

  app.component('ReportParam_UNC', ReportParam_UNC);
  app.component('ReportParam_UNC_Excel', ReportParam_UNC_Excel);
  app.component('ReportParam_Payment_Order_Techcombank', ReportParam_Payment_Order_Techcombank);

  app.component('ReportParamC41BB', ReportParamC41BB);
  app.component('ReportParamC40BB', ReportParamC40BB);

  app.component('ReportS101_H_I', ReportS101_H_I);

  app.component('ReportParam_S101_H_2', ReportParam_S101_H_2);
  app.component('ReportParam_RetroSalary', ReportParam_RetroSalary);
  app.component('ReportParam_RetroSalaryForMonth', ReportParam_RetroSalaryForMonth);
  app.component('ReportParam_Pa_Other_Outcome', ReportParam_Pa_Other_Outcome);
  app.component('ReportParam_S02a_H', ReportParam_S02a_H);
  app.component('ReportParam_S02a_H_Voucher', ReportParam_S02a_H_Voucher);
  app.component('ReportParam_S02a_H_PostedVoucher', ReportParam_S02a_H_PostedVoucher);
  app.component('PaymentVoucherListPrintFromVoucher_ND11_2020', PaymentVoucherListPrintFromVoucher_ND11_2020);
  app.component(
    'PaymentVoucherListPrintFromVoucher_ND11_2020_vertical',
    PaymentVoucherListPrintFromVoucher_ND11_2020_vertical,
  );
  app.component('ReportParam_N01a_SDKP_DVDT_ND112020', ReportParam_N01a_SDKP_DVDT_ND112020);
  app.component('ReportParam_N01b_SDKP_DVDT_ND112020', ReportParam_N01b_SDKP_DVDT_ND112020);
  app.component('ReportParam_N02a_SDKP_DVDT_ND112020', ReportParam_N02a_SDKP_DVDT_ND112020);
  app.component('ReportParam_N02b_SDKP_DVDT_ND112020', ReportParam_N02b_SDKP_DVDT_ND112020);
  app.component('C2_05_NS_ND11', C2_05_NS_ND11);
  app.component('C1_02_NS_ND11', C1_02_NS_ND11);
  app.component('ReportParamS101HPIII', ReportParamS101HPIII);
  app.component('ReportParamS26H', ReportParamS26H);
  app.component('ReportParam_PurchaseDiary', ReportParam_PurchaseDiary);
  app.component('ReportParamS62H', ReportParamS62H);

  // Tham số in chứng từ (chứng từ kế toán - vqphong - 03/11/2022)
  app.component('ReportParamAccountVoucher', ReportParamAccountVoucher);
  app.component('ReportParamAccountVoucherSummarySameInfo', ReportParamAccountVoucherSummarySameInfo);
  app.component('C402bKBND11', C402bKBND11);
  app.component('ReportParam_S01B', ReportParam_S01B);
  app.component('SalaryMS09', SalaryMS09);
  app.component('SalaryMS09_PayrollItemFormula', SalaryMS09_PayrollItemFormula);

  app.component('ReportParamS01H', ReportParamS01H);

  app.component('ReportParamVoucherByTypeDiary', ReportParamVoucherByTypeDiary);

  app.component('C408_KB_TT19', C408_KB_TT19);
  app.component('C202aNSND112020_WithBankAccount_Offline', C202aNSND112020_WithBankAccount_Offline);
  app.component('C202bNSND112020_WithBankAccount_Offline', C202bNSND112020_WithBankAccount_Offline);
  app.component('ReportParamC3ND112020', ReportParamC3ND112020);
  app.component('ReportParamC3ND112020_105', ReportParamC3ND112020_105);
  app.component('ReportParamDNTHV04b', ReportParamDNTHV04b);
  app.component('ReportParam_C02_HD_Salary', ReportParam_C02_HD_Salary);
  app.component('ReportParam_C13_HD_Salary', ReportParam_C13_HD_Salary);
  app.component('ReportParam_Other_Income_Table', ReportParam_Other_Income_Table);
  app.component('ReportParam_SalarySheetNomal', ReportParam_SalarySheetNomal);
  app.component('ReportParamLiabilityByObjectPurchase', ReportParamLiabilityByObjectPurchase);
  app.component('ReportParamSummaryPayable', ReportParamSummaryPayable);
  //Tham số báo cáo số dư các chi tiết của 1 tài khoản
  app.component('ReportParam_AccountDetailBalance', ReportParam_AccountDetailBalance);
  //Tham số báo cáo đối chiếu hạch toán tài chính và hạch toán ngoài bảng
  app.component('ReportParam_ComparisonReportParalell', ReportParam_ComparisonReportParalell);
  //Tham số báo cáo tổng hợp tình hình kinh phí dự án
  app.component('ReportParam_SummaryProjectExpense', ReportParam_SummaryProjectExpense);
  app.component('ReportParamS51H', ReportParamS51H);
  // Tham số in chứng từ (chứng từ C3-02NS_ND11 - ncdinh - 24/11/2022)
  app.component('C3-02NS_ND11', ReportParam_C302NS_ND11);
  app.component('ReportParam_C302NS_ND11', ReportParam_C302NS_ND11);

  app.component('ReportParam_LiabilityObjectMonitor', ReportParam_LiabilityObjectMonitor);
  app.component('ReportParam_SummaryReceivable', ReportParam_SummaryReceivable);

  app.component('ReportParamS22H', ReportParamS22H);
  app.component('ReportParamS23H', ReportParamS23H);
  // Báo cáo tồn kho theo theo chứng từ nhập
  app.component('ReportParam_InventoryInStockByInward', ReportParam_InventoryInStockByInward);

  app.component('C31_HD', C31_HD);
  app.component('C43_BB', C43_BB);
  // Mẫu Báo cáo tổng hợp công nợ NHCUONG 07.12.2022
  app.component('ReportParam_SummaryOther', ReportParam_SummaryOther);

  app.component('ReportParam_DCSD_N01a_SDKP_DVDT_ND112020', ReportParam_DCSD_N01a_SDKP_DVDT_ND112020);
  app.component('ReportParam_DCSD_N02a_SDKP_DVDT_ND112020', ReportParam_DCSD_N02a_SDKP_DVDT_ND112020);
  app.component('ReportParam_DCSD_N04a_SDKP_DVDT_ND112020', ReportParam_DCSD_N04a_SDKP_DVDT_ND112020);
  app.component('AccountLedgerDetail', AccountLedgerDetail);
  // Tham số báo cáo S24H-Sổ tài sản cố định
  app.component('ReportParam_S24H', ReportParam_S24H);
  // Tham số báo cáo Danh sách tài sản cố định theo loại
  app.component('ReportParam_FixedAssetListingUsedDepartment', ReportParam_FixedAssetListingUsedDepartment);

  // Tham số in chứng từ C02-17a. Lệ ghi thu, ghi chi ngân sách theo thông tư 19-2020 TT-BTC PTTAM2 19.12.2022
  app.component(
    'ReportParam_PaymentVoucherList_C217aNS192020_TTBTC',
    ReportParam_PaymentVoucherList_C217aNS192020_TTBTC,
  );

  // Báo cáo Số theo dõi tạm ứng
  app.component('ReportParam_AdvanceTracking', ReportParam_AdvanceTracking);
  // Báo cáo danh sách chứng từ chưa sinh hạch toán đồng thời
  app.component('ReportParam_VoucherNoParalell', ReportParam_VoucherNoParalell);
  // Báo cáo Sổ cái tài khoản nhóm theo đối ứng
  app.component('ReportParam_GeneralLedgerCorresponding', ReportParam_GeneralLedgerCorresponding);
  app.component('ReportParam_S52H', ReportParam_S52H);
  // Mẫu tham số báo cáo cho kho bạc điện tử - Quản lý hồ sơ đối chiếu số dư - ncdinh 19/12/022
  app.component('ReportParam_DCSD_06_DCSDTK_KBNN', ReportParam_DCSD_06_DCSDTK_KBNN);
  app.component('ReportParam_C34_HD', ReportParam_C34_HD);
  app.component('InwardOutwardDetailByVoucher', InwardOutwardDetailByVoucher);

  app.component('ReportParam_MinutesInventoryFixedAsset', ReportParam_MinutesInventoryFixedAsset);
  app.component('ReportParamDecrementLedger', ReportParamDecrementLedger);
  app.component('SummaryProjectExpenseToUsed', SummaryProjectExpenseToUsed);

  app.component('ReportParam_S26H', ReportParam_S26H);

  // báo cáo kiểm kê tài sản cố định
  app.component('ReportParam_Inventory_FixedAsset', ReportParam_Inventory_FixedAsset);
  //  Báo cáo tình hình tăng giảm TSCĐ theo mẫu QĐ 19/2006 để phản ánh tình hình tài sản hiện có tại đơn vị
  app.component('ReportParam_UpDown_FixedAsset', ReportParam_UpDown_FixedAsset);
  app.component('ReportParam_F02_01H_QD19', ReportParam_F02_01H_QD19);

  app.component('ReportParam_ReportSaleVoucherCompare', ReportParam_ReportSaleVoucherCompare);
  // Đối chiếu chứng từ mua hàng và thanh toán
  app.component('ReportParamComparePUInvoiceAndPayment', ReportParamComparePUInvoiceAndPayment);

  // Báo cáo quyết toán tổng hợp nhập xuất tồn
  app.component('ReportParam_GeneralImportExportReserveSettlement', ReportParam_GeneralImportExportReserveSettlement);
  app.component('ReportParam_VoucherListByStatisticsCode', ReportParam_VoucherListByStatisticsCode);
  app.component('ReportParam_AccountingVoucherList', ReportParam_AccountingVoucherList);

  app.component('ReportParam_InventoryFixedAssetDepartment', ReportParam_InventoryFixedAssetDepartment);
  app.component('ReportParam_AttritionCaculateBook', ReportParam_AttritionCaculateBook);
  app.component('ReportParam_B03_TT90_2018_KTNN', ReportParam_B03_TT90_2018_KTNN);
  app.component('ReportParam_DifferenceReceiptExpenseByActivity', ReportParam_DifferenceReceiptExpenseByActivity);
  app.component('ReportParam_08QTDA', ReportParam_08QTDA);
  app.component('ReportParam_CDT_B03', ReportParam_CDT_B03);
  app.component('ReportParam_01QTDA', ReportParam_01QTDA);
  app.component('ReportParam_B58_KTNNNew', ReportParam_B58_KTNNNew);
  app.component('ReportParam_CDT_F02', ReportParam_CDT_F02);

  app.component('ReportParam_BudgetActivitySGDHD', ReportParam_BudgetActivitySGDHD);
  app.component('ReportParam_CDT_F03A', ReportParam_CDT_F03A);
  app.component('ReportParam_CDT_F03C', ReportParam_CDT_F03C);
  app.component('ReportParam_CDT_F03B', ReportParam_CDT_F03B);
  app.component('ReportParam_CDT_B02', ReportParam_CDT_B02);
  app.component('ReportParam_C24', ReportParam_C24);
  app.component('ReportParam_04QTDA', ReportParam_04QTDA);
  app.component('ReportParam_01_01_BCQT_KTNN', ReportParam_01_01_BCQT_KTNN);
  app.component('ReportParam_01_01_BCQT_TCTK', ReportParam_01_01_BCQT_TCTK);
  app.component('ReportParam_B58_KTNN', ReportParam_B58_KTNN);
  app.component('ReportParamB01_BCQT_HD', ReportParamB01_BCQT_HD);
  app.component('ReportParam_SummaryByAccount', ReportParam_SummaryByAccount);

  app.component('ReportParam_Government', ReportParam_Government);
  app.component('ReportParam_C03_CCTT', ReportParam_C03_CCTT);
  app.component('ReportParam_B03_TT90_2018', ReportParam_B03_TT90_2018);
  app.component('ReportParamBS59', ReportParamBS59);
  app.component('ReportParamB04TT612017BTC', ReportParamB04TT612017BTC);
  app.component('ReportParam_MA1_BCQT', ReportParam_MA1_BCQT);
  app.component('ReportParamIncrementFixedAssetBook', ReportParamIncrementFixedAssetBook);
  app.component('ReportParam_OSStatisticByDepartment', ReportParam_OSStatisticByDepartment);
  app.component('ReportParamSummaryReceiptM02', ReportParamSummaryReceiptM02);
  app.component('ReportParam_B04_TT90', ReportParam_B04_TT90);
  app.component('ReportParam_C23_HD', ReportParam_C23_HD);
  app.component('ReportParam_TT3422016_B59_KTNN', ReportParam_TT3422016_B59_KTNN);
  app.component('C210NSTT77', C210NSTT77);
  app.component('ReportParamReportingGovernment', ReportParamReportingGovernment);
  app.component('ReportParam_03_SDKP_ĐVDT', ReportParam_03_SDKP_ĐVDT);
  app.component('ReportParamAdvanceWithdrawByBudget', ReportParamAdvanceWithdrawByBudget);
  app.component('ReportParamRealExpense', ReportParamRealExpense);
  app.component('FixedAssetDecreaseList', FixedAssetDecreaseList);
  app.component('ReportParam_S53_H', ReportParam_S53_H);
  app.component('ReportParamMinutesInventoryTool', ReportParamMinutesInventoryTool);
  app.component('ReportParam_VHL_SummaryProject', ReportParam_VHL_SummaryProject);
  app.component('ReportParam_VHL_DetailProject', ReportParam_VHL_DetailProject);
  app.component('ReportParam_BudgetSourceUsing_BTTTT', ReportParam_BudgetSourceUsing_BTTTT);

  // Tham số Báo cáo Bảng kê chi tiết chứng từ
  app.component('ReportParam_DetailByAccountingSource', ReportParam_DetailByAccountingSource);
  app.component('ReportParam_B05_BTTTT', ReportParam_B05_BTTTT);
  app.component('ReportParam_B03_BCQT_BTTTT', ReportParam_B03_BCQT_BTTTT);
  app.component('ReportParamPerformPaymentCommitment', ReportParamPerformPaymentCommitment);
  app.component('ReportParam_AccountBookingExtension007', ReportParam_AccountBookingExtension007);
  app.component('ReportParam_AccountBookingByProject', ReportParam_AccountBookingByProject);
  app.component('ReportParam_S103H_P1', ReportParam_S103H_P1);
  app.component('ReportParam_S33H', ReportParam_S33H);
  app.component('ReportParam_PayableDetailByCurrency', ReportParam_PayableDetailByCurrency);
  app.component('ReportParam_0501BK_QTT_TNCN', ReportParam_0501BK_QTT_TNCN);
  app.component('ReportParam_05_02_BK_QTT_TNCN', ReportParam_05_02_BK_QTT_TNCN);

  app.component('ReportParam_S103HPII', ReportParam_S103HPII);

  app.component('ParamForexOrderVietinBank', ParamForexOrderVietinBank);

  app.component('ReportParam_S102_H_2', ReportParam_S102_H_2);
  app.component('ReportParam_05QTT_TNCN', ReportParam_05QTT_TNCN);
  app.component('ReportParam_ReceivablePayableSummaryByCurrency', ReportParam_ReceivablePayableSummaryByCurrency);
  app.component('ReportParam_ReceiptableDetailByCurrency', ReportParam_ReceiptableDetailByCurrency);
  app.component('ReportParamSummaryPayableByCurrency', ReportParamSummaryPayableByCurrency);
  app.component('PaymentVoucherListPrintFromVoucher_TT39_2016', PaymentVoucherListPrintFromVoucher_TT39_2016);
  app.component('C3-02NS_TT77', ReportParam_C302NS_TT77);
  app.component('ReportParam_ListDataForPaymentNoPUInvoice', ReportParam_ListDataForPaymentNoPUInvoice);
  app.component('ReportParam_BudgetActivity', ReportParam_BudgetActivity);

  // offline

  app.component('PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline', PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline);
  app.component('ReportParamAccountVoucher_Offline', ReportParamAccountVoucher_Offline);
  
}
